import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "mb-12 font-bold text-6xl" }, "Todo List.", -1)
const _hoisted_3 = { class: "flex gap-2 my-2" }
const _hoisted_4 = { class: "bg-white shadow overflow-hidden rounded-md" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Todo = _resolveComponent("Todo")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _withDirectives(_createVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.task = $event)),
        class: "rounded w-full p-2",
        type: "text",
        placeholder: "What do you need to?"
      }, null, 512), [
        [_vModelText, _ctx.task]
      ]),
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.insertTask(...args))),
        class: "btn-black"
      }, " Add ")
    ]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allTodos, (todo, index) => {
        return (_openBlock(), _createBlock("ul", { key: index }, [
          _createVNode(_component_Todo, { todo: todo }, null, 8, ["todo"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}